import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import {SearchQuery} from '../models/search-query.model';
import { FilterComponentBase, IFilterList, FilterKeys, Filter } from '../filters/filters';
import { AviationEventFilter } from '../../shared/models/aviation-event-filter.model';
import { AviationEventFiltersService } from '../../shared/services/aviation-event-filters.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';


@Component({
  selector: 'app-event-filter-list',
  templateUrl: './event-filter-list.component.html',
  styleUrls: ['./event-filter-list.component.scss']
})
export class EventFilterListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() compact: boolean;
  @Input() query: SearchQuery;
  @Output() filtersChange = new EventEmitter<void>();
  @Output() filtersChangeDate = new EventEmitter<void>();
  @Output() numSelectedChange = new EventEmitter<number>();

  @ViewChildren(FilterComponentBase) filterComponents: QueryList<FilterComponentBase>;

  aviationEventFilter = new AviationEventFilter();
  aviationEventFilterSubscription: Subscription;

  constructor(private _aviationEventFiltersService: AviationEventFiltersService,
              private _cdref: ChangeDetectorRef,
              private _analyticsService: AnalyticsService) { }

  ngOnInit() {
    if (!this.aviationEventFilter.startDate) {
      this.aviationEventFilter.startDate = new Date();
    }
    if (!this.aviationEventFilter.endDate) {
      this.aviationEventFilter.endDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    }
    this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(ae => {
      this.aviationEventFilter = ae;
    });
    this._analyticsService.pageView('airport_landingpage_event', 'Event Landing Page filters');
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.aviationEventFilterSubscription.unsubscribe();
  }

  onSelectAllCommunityEvents() {
    this.aviationEventFilter.airshow = true;
    this.aviationEventFilter.airshowwithmilitarydemonstrationteam = true;
    this.aviationEventFilter.flyin = true;
    this.aviationEventFilter.flyout = true;
    this.aviationEventFilter.pancakeBreakfast = true;
    this.aviationEventFilter.socialGathering = true;
    this.aviationEventFilter.openhouse = true;
    this.aviationEventFilter.pokerRun = true;
    this.aviationEventFilter.aviationCommunityDay = true;
    this.aviationEventFilter.wingsAndWheels = true;
    this.aviationEventFilter.aircraftDisplayRides = true;
    /* this.aviationEventFilter.webinar = false;
    this.aviationEventFilter.virtualPresentation = false; */
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onClearAllCommunityEvents() {
    this.aviationEventFilter.airshow = false;
    this.aviationEventFilter.airshowwithmilitarydemonstrationteam = false;
    this.aviationEventFilter.flyin = false;
    this.aviationEventFilter.flyout = false;
    this.aviationEventFilter.pancakeBreakfast = false;
    this.aviationEventFilter.socialGathering = false;
    this.aviationEventFilter.openhouse = false;
    this.aviationEventFilter.pokerRun = false;
    this.aviationEventFilter.aviationCommunityDay = false;
    this.aviationEventFilter.wingsAndWheels = false;
    this.aviationEventFilter.aircraftDisplayRides = false;
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onSelectAllSeminars() {
    this.aviationEventFilter.aopaRustyPilots = true;
    this.aviationEventFilter.aopaFlyingClub = true;
    this.aviationEventFilter.safetySeminar = true;
    this.aviationEventFilter.conference = true;
    this.aviationEventFilter.workshop = true;
    this.aviationEventFilter.aopaBacktoYourRoots = true;
    /* this.aviationEventFilter.webinar = false;
    this.aviationEventFilter.virtualPresentation = false; */
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onClearAllSeminars() {
    this.aviationEventFilter.aopaRustyPilots = false;
    this.aviationEventFilter.aopaFlyingClub = false;
    this.aviationEventFilter.safetySeminar = false;
    this.aviationEventFilter.conference = false;
    this.aviationEventFilter.workshop = false;
    this.aviationEventFilter.aopaBacktoYourRoots = false;
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onChangeFormat(formatType: string) {
    if (!this.aviationEventFilter.formatInPerson && !this.aviationEventFilter.formatOnline) {
      // both formats of events can't be off, turn on the opposite type
      if (formatType === 'formatInPerson') {
        this.aviationEventFilter.formatOnline = true;
      } else {
        this.aviationEventFilter.formatInPerson = true;
      }
    }
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onChangeInPersonEvent(event: any) {
    if (event.airshow) {
      this._cdref.detectChanges();
      this.aviationEventFilter.airshowwithmilitarydemonstrationteam = true;
    }
    this._aviationEventFiltersService.updateAviationEventFilters(this.aviationEventFilter);
    this.filtersChange.emit();
  }

  onEventNameChange(event: any) {
    this.filtersChange.emit();
  }

  onChangeDate(dateType: string, event: any) {
    if (dateType === 'start') {
      this.aviationEventFilter.startDate = new Date(event.value);
    } else if (dateType === 'end') {
      this.aviationEventFilter.endDate = new Date(event.value);
    }
    this.filtersChangeDate.emit();
  }

}
